// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function get(object: any, path: string) {
  return path.split('.').reduce((prev, curr) => {
    return prev ? prev[curr] : null
  }, object)
}
